// extracted by mini-css-extract-plugin
export default {"giftOrPromoRowWrapper":"ru-z","giftOrPromoSelector":"su-z","disabled":"tu-z","subTitle":"uu-z","selectShipAddressMessage":"vu-z","changePayment":"wu-z"};